import { render, staticRenderFns } from "./LoadingBaseSelect.vue?vue&type=template&id=48bd7907&lang=pug"
import script from "./LoadingBaseSelect.vue?vue&type=script&lang=js"
export * from "./LoadingBaseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports